import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import {
    Divider, Typography, Chip, Paper, CircularProgress, withStyles, Button, Link, Dialog, DialogContent, List, ListItem,
    ListItemIcon, ListItemText, Radio, Avatar
} from '@material-ui/core'
import { Close, } from '@material-ui/icons';
import { formatCurrency } from "../../../util/formatters";
import APIService from "../../../apis/amplify/APIService"
import DeviceIcon from "../../../components/DeviceIcon";
import { loadPaymentPending } from '../../../apis/redux/paymentOrderPendingActions';
import { receive_cards, remove_notification } from "../../../apis/redux/fetchActions";
import { SectionTitle } from "../../../components/SectionTitleContainer";
import SectionTitleContainer from "../../../components/SectionTitleContainer";
import Loading, { LoadingText, Progress } from "../../../components/Loading";
import DialogTitleContainer, { Title, TitleButton } from "../../../components/DialogTitleContainer";
import If from "../../../components/If";
import { errorBundaryHOC } from "../../../components/ErrorBoundary";
import CreditCardItem, { CardBrand, CardDigits, CardIcon } from "../../../components/CreditCardItem";
import { styles } from './styles'

const LOADING_PAYMENT_MSG = 'Loading payment order...';
const LOADING_CARD_MSG = 'Loading card...';

class OrderPaymentContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            paying: false,
            payed: false,
            paymentData: null,
            selectedCard: null,
            changeCardDialogOpen: false,
            loadingCards: false,
        }
    }

    componentDidMount() {
        const { pendingPaymentData, cardsList, actions } = this.props;
        if (!pendingPaymentData || !pendingPaymentData.founded) {
            actions.loadPaymentPending();
        }
        if (!cardsList || !cardsList.length) {
            this.loadCreditCards();
        }
    }

    async loadCreditCards() {
        this.setState({ loadingCards: true });
        const { ok, data } = await APIService.getPaymentCardList();
        this.setState({ loadingCards: false });
        if (ok) {
            this.props.actions.receiveCards(data);
        }
    }

    async pay() {
        const { pendingPaymentData: { appointment_data: aptmData }, orderPaymentNotifId, actions } = this.props;
        const { selectedCard } = this.state;
        this.setState({ paying: true, });
        const { ok } = await APIService.payAppointmentFinished(aptmData.id, {
            payment_token: selectedCard.id,
            is_new: false,
            total: aptmData.priceToPay
        });
        if (ok) {
            this.setState({ payed: true });
            actions.removeNotification(orderPaymentNotifId)
        }
        this.setState({ paying: false });
    }

    getSubtotalByDevice(issues) {
        if (issues.length === 0)
            return 0;
        else {
            let result = 0;
            for (let i = 0; i < issues.length; i++) {
                result = result + issues[i].price
            }
            return result;
        }
    }

    selectCard(card) {
        this.setState({ selectedCard: card, changeCardDialogOpen: false });
    }

    renderCardsList() {
        const { cardsList } = this.props;
        if (cardsList)
            return (
                <List>
                    {
                        cardsList.map(card => (
                            <ListItem key={card.id} onClick={this.selectCard.bind(this, card)} button
                                      style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                <Radio checked={this.state.selectedCard === card} color='primary'/>
                                <ListItemIcon style={{ padding: '5px', marginRight: 0 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
                                        <g>
                                            <path id="path1"
                                                  transform="rotate(0,12,12) translate(0,3.75) scale(0.75,0.75)  "
                                                  fill="#000000"
                                                  d="M18,16L25,16C25.552999,16 26,16.448 26,17 26,17.552 25.552999,18 25,18L18,18C17.447001,18 17,17.552 17,17 17,16.448 17.447001,16 18,16z M2,11L2,20 30.000977,20 30.000488,11z M2,7L2,9 30.00038,9 30.000271,7z M2,2L2,5 30.000162,5 30,2z M2,0L30,0C31.103027,0,32,0.89700317,32,2L32,20C32,21.102997,31.103027,22,30,22L2,22C0.89697266,22,0,21.102997,0,20L0,2C0,0.89700317,0.89697266,0,2,0z"/>
                                        </g>
                                    </svg>
                                </ListItemIcon>
                                <ListItemText primary={<span>●●●● ●●●● ●●●● {card.last4}</span>}
                                              secondary={card.brand}/>
                            </ListItem>
                        ))
                    }
                </List>)
    }

    renderServices(issues) {
        return issues.map(issue => (
            <Chip
                key={issue.id}
                className={this.props.classes.issueChip}
                label={`${issue.name} - ${formatCurrency(issue.price)}`}
            />));
    };

    renderDoneMessage() {
        const { classes } = this.props;
        return (
            <Paper className={classes.wellDoneSpace} style={{ backgroundColor: '#74bd43' }}>
                <div className={classes.headerDiv}>
                    <Avatar className={classes.avatar}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"
                             viewBox="0 0 24 24">
                            <g>
                                <path id="path1"
                                      transform="rotate(0,12,12) translate(0,0.0885084723758816) scale(0.750023112413235,0.750023112413235)  "
                                      fill="#74bd43"
                                      d="M26.25644,26.439999L26.185838,26.444053C25.750988,26.494261,25.409971,26.911737,25.409971,27.417996L25.409971,27.805996C25.409971,28.232998,25.651976,28.60899,26.011992,28.739986L26.492368,28.893606 26.514841,28.888632C26.791502,28.826891,27.004744,28.775795,27.14201,28.741999L27.141009,28.739999C27.502009,28.608999,27.744008,28.232999,27.744008,27.805999L27.744008,27.418C27.744008,26.877999,27.356009,26.439999,26.88001,26.439999z M24.987524,22.101994L24.916882,22.106051C24.482153,22.156258,24.142016,22.573739,24.142016,23.07999L24.142016,23.46899C24.142016,24.00899,24.529016,24.447991,25.005016,24.447991L25.447014,24.447991 28.148015,24.447991C28.624013,24.447991,29.012012,24.00899,29.012012,23.46899L29.012012,23.07999C29.012012,22.573739,28.670998,22.156258,28.23616,22.106051L28.16551,22.101994 26.709016,22.101994 26.444003,22.101994z M24.009014,17.764995C23.533014,17.764995,23.145013,18.203995,23.145013,18.743995L23.145013,19.131995C23.145013,19.671994,23.533014,20.110994,24.009014,20.110994L24.966886,20.110994 25.005016,20.109987 25.447026,20.109987 27.706018,20.109987 28.148015,20.109987 28.186146,20.110994 29.145009,20.110994C29.621009,20.110994,30.00801,19.671994,30.00801,19.131995L30.00801,18.743995C30.00801,18.203995,29.621009,17.764995,29.145009,17.764995L26.709016,17.764995 26.444003,17.764995z M1.9910011,17.450993L1.9910011,29.397993 4.9780045,29.397993 4.9780045,17.450993z M24.884008,13.427993C24.262009,13.427993 23.81001,13.900992 23.81001,14.553992 23.81001,15.225991 24.292009,15.773992 24.884008,15.773992L26.444003,15.773996 26.709016,15.773996 28.268917,15.773996C28.862011,15.773992 29.345012,15.225991 29.345012,14.552992 29.345012,13.900992 28.893012,13.427993 28.269011,13.427993L28.268005,13.427993z M16.133114,1.9971008C16.936121,5.1670818 15.70711,8.9800606 15.64511,9.16506 15.581109,9.3600588 15.459108,9.5290575 15.295106,9.6520567 10.995067,12.862039 10.25106,17.365014 10.24406,17.410013 10.169059,17.894011 9.7510548,18.255009 9.2600498,18.255009L6.9690056,18.255009 6.9690056,27.223507 7.0000057,27.226094C8.370265,27.34485 11.559884,27.73628 13.920035,28.922999 16.645655,30.099873 20.63885,29.855655 23.556852,29.431553L23.860496,29.385718 23.829498,29.336884C23.565179,28.883723,23.417991,28.357684,23.417991,27.805996L23.417991,27.417996C23.417991,26.986101,23.507118,26.57548,23.667226,26.204941L23.709981,26.114417 23.645614,26.080069C22.756015,25.576609,22.151014,24.595116,22.151014,23.46899L22.151014,23.07999C22.151014,22.568427,22.276014,22.086551,22.495924,21.665766L22.502754,21.653418 22.413974,21.594162C21.654403,21.059963,21.154012,20.155744,21.154012,19.131995L21.154012,18.743995C21.154012,17.771433,21.605615,16.906748,22.302012,16.364701L22.338545,16.33766 22.298011,16.275866C21.994761,15.777741 21.819012,15.186491 21.819012,14.552992 21.819012,14.170835 21.88342,13.806767 22.002051,13.471161L22.018501,13.427993 20.372005,13.427993C20.337631,13.427993,20.303662,13.42625,20.270183,13.42285L20.198436,13.411898 20.192949,13.518827C20.171511,14.009083 20.167527,14.53053 20.188152,15.078027 20.272153,15.631023 20.572155,18.480007 18.279134,21.225992 18.083132,21.461991 17.80013,21.58399 17.514127,21.58399 17.289125,21.58399 17.063123,21.50799 16.877121,21.352991 16.455117,21.000993 16.398117,20.372997 16.75112,19.950999 18.618137,17.713012 18.234134,15.460025 18.217134,15.365025 18.208134,15.320025 18.202134,15.266026 18.200133,15.220026 18.053132,11.598046 18.87014,9.0090609 19.043141,8.5070639 19.558146,5.8050785 19.405145,3.8700905 18.598137,2.9110947 18.003131,2.2030983 17.058123,2.0300999 16.133114,1.9971008z M15.664587,2.6702881E-05C17.007013,-0.0023097992 18.87964,0.15048599 20.122151,1.6301022 21.371163,3.1150932 21.652166,5.5120811 20.984159,8.9580612 20.974159,9.0120611 20.960159,9.0640602 20.940159,9.1150599 20.935409,9.1281223 20.624652,9.9925623 20.400577,11.426216L20.398962,11.436994 24.884008,11.436994 28.268005,11.436994 28.269011,11.436994C29.989012,11.436994 31.336013,12.805993 31.336013,14.553992 31.336013,15.187492 31.159763,15.778742 30.856013,16.276866L30.815765,16.338128 30.851651,16.364701C31.547763,16.906748,31.999014,17.771433,31.999014,18.743995L31.999014,19.131995C31.999014,20.155744,31.499013,21.059963,30.739734,21.594162L30.651018,21.653397 30.657864,21.665766C30.877907,22.086551,31.003004,22.568427,31.003004,23.07999L31.003004,23.46899C31.003004,24.582319,30.411216,25.554284,29.53787,26.062721L29.444565,26.114275 29.452998,26.131378C29.633676,26.52083,29.735004,26.957312,29.735004,27.418L29.735004,27.805999C29.735004,29.064999,28.970006,30.189998,27.830008,30.607998L27.833008,30.620998C27.580009,30.687998 23.483016,31.762998 19.175025,31.762998 17.049029,31.762998 14.870033,31.500998 13.078036,30.725998 11.144603,29.755686 8.4806957,29.376366 7.1199627,29.239009L6.9690056,29.224287 6.9690056,30.392992C6.9690056,30.942992,6.5240059,31.388992,5.9740047,31.388992L0.99600029,31.388992C0.44600105,31.388992,0,30.942992,0,30.392992L0,16.455993C0,15.905993,0.44600105,15.459993,0.99600029,15.459993L5.9740047,15.459993C6.4552555,15.459993,6.8561153,15.801462,6.9488106,16.255286L6.95014,16.26402 8.4630423,16.26402C8.8910465,14.657029 10.203059,11.093049 13.838093,8.2590656 14.128096,7.2310715 14.999104,3.6600914 13.823092,1.4801025 13.657091,1.1721058 13.665092,0.7991066 13.845093,0.49710846 14.024095,0.19610977 14.348098,0.012111664 14.6991,0.012111664L15.125105,0.0071105957C15.291857,0.0038604736,15.472811,0.00036048889,15.664587,2.6702881E-05z"/>
                            </g>
                        </svg>

                    </Avatar>
                    <Typography variant='h6' className={classes.headerTypography}>
                        Congratulations
                    </Typography>

                </div>
                <p className={classes.paragraph}>
                    Your request has been registered successfully.<br/>
                    Our technician will contact you soon.<br/>
                    <br/>
                    You can cancel the appointment in the <Link underline='always'
                                                                style={{
                                                                    color: 'white',
                                                                    fontWeight: '500'
                                                                }}>Pending
                    Appointments</Link> page located in the main menu.
                    <br/>
                    Thanks for trust in us.
                </p>
            </Paper>
        )
    }

    renderDevicesData() {
        const { classes, pendingPaymentData } = this.props;
        return pendingPaymentData.appointment_data.service_item_list.map((device, i) => (
            <div key={i} className={classes.paper}>
                <div className={classes.itemMainDiv}>
                    <div className={classes.itemHeader}>
                        <DeviceIcon deviceName={device.device_name}/>
                        <Typography color='primary' variant="subtitle1"
                                    noWrap={true}
                                    className={classes.itemTitle}>
                            {device.device_name}
                        </Typography>
                        <div className={classes.colorPaper}>
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 height="17"
                                 width="17"
                                 viewBox="0 0 17 17">
                                <g>
                                    <path id="path1"
                                          transform="rotate(0,8.5,8.5) translate(0,0) scale(0.53125,0.53125)  "
                                          fill={device.device_color.code}
                                          d="M16,0C24.837036,0 32,7.1629944 32,16 32,24.836975 24.837036,32 16,32 7.1630249,32 0,24.836975 0,16 0,7.1629944 7.1630249,0 16,0z"/>
                                </g>
                            </svg>
                            <Typography variant="subtitle2" align='center'
                                        noWrap={true}
                                        className={classes.colorName}>
                                {device.device_color.name}
                            </Typography>
                        </div>
                    </div>
                    <div className={classes.issuesDesktop}>
                        <Typography gutterBottom variant="subtitle2"
                                    align='left'>
                            Services {<span
                            style={{ fontWeight: 'bold' }}>({formatCurrency(this.getSubtotalByDevice(device.services))})</span>}
                        </Typography>
                        {this.renderServices(device.services)}
                    </div>
                    <div className={classes.issuesMobil}>
                        <Typography gutterBottom variant="subtitle2"
                                    align='left'>
                            Price: {<span
                            style={{ fontWeight: 'bold' }}>{formatCurrency(this.getSubtotalByDevice(device.services))}</span>}
                        </Typography>
                    </div>
                </div>
            </div>
        ))
    }

    render() {
        const { selectedCard, loadingCards } = this.state;
        const { classes, loadingPendingPayment, pendingPaymentData, cardsList } = this.props;
        const { appointment_data: aptmData } = pendingPaymentData || {};
        if (!selectedCard && cardsList && cardsList.length) {
            setTimeout(() => this.setState({ selectedCard: cardsList.find(c => c.default_card) }))
        }
        return (
            <Fragment>

                <Dialog open={this.state.changeCardDialogOpen}
                        disableBackdropClick={false}
                        PaperProps={{ className: classes.modalDialog }}
                        onBackdropClick={() => this.setState({ changeCardDialogOpen: false })}>
                    <DialogTitleContainer>
                        <Title>SELECT CREDIT CARD</Title>
                        <TitleButton location="right" onClick={() => this.setState({ changeCardDialogOpen: false })}>
                            <Close/>
                        </TitleButton>
                    </DialogTitleContainer>
                    <DialogContent style={{ padding: 0 }}>
                        {this.renderCardsList()}
                    </DialogContent>
                </Dialog>

                <div className={classes.componentDiv}>
                    {
                        this.state.payed ? this.renderDoneMessage() :
                            (
                                <Fragment>
                                    <SectionTitleContainer>
                                        <SectionTitle>Order Payment Summary</SectionTitle>
                                    </SectionTitleContainer>
                                    <If condition={loadingPendingPayment} as={Loading} style={{ marginTop: 30 }}>
                                        <Progress/><LoadingText>{LOADING_PAYMENT_MSG}</LoadingText>
                                    </If>
                                    <If as="div" condition={!loadingPendingPayment && !aptmData}
                                        style={{ padding: '0 10px' }}>
                                        <p style={{ textAlign: 'center' }}>
                                            There is no pending payment in this moment.
                                        </p>
                                    </If>
                                    {
                                        aptmData && (
                                            <Fragment>
                                                <div className={classes.dataContainer}>
                                                    <div className={cn(classes.paper, 'amountContainer')}>
                                                        <Typography variant='subtitle2'>
                                                            Subtotal: {formatCurrency(aptmData.subtotalWithoutTaxes)}
                                                        </Typography>
                                                        <Typography variant='subtitle2'>
                                                            Taxes: {formatCurrency(aptmData.taxesToPay)}
                                                        </Typography>
                                                        <Typography color='primary' variant='subtitle2'
                                                                    style={{ fontWeight: 'bold' }}>
                                                            Total: {formatCurrency(aptmData.priceToPaySaved)}
                                                        </Typography>
                                                    </div>

                                                    {this.renderDevicesData()}

                                                    <div className={classes.paper}
                                                         style={{ marginBottom: 0, display: 'flex' }}>
                                                        {selectedCard &&
                                                        <CreditCardItem>
                                                            <CardIcon/>
                                                            <div style={{ marginLeft: 10 }}>
                                                                <CardDigits digits={selectedCard.last4}/>
                                                                <CardBrand>{selectedCard.brand}</CardBrand>
                                                            </div>
                                                        </CreditCardItem>
                                                        }
                                                        <If as={Loading}
                                                            condition={loadingCards}>
                                                            <Progress/><LoadingText>{LOADING_CARD_MSG}</LoadingText>
                                                        </If>
                                                        <div style={{ flexGrow: 1 }}/>
                                                        <If as={Link} condition={!loadingCards}
                                                            onClick={() => this.setState({ changeCardDialogOpen: true })}
                                                            color='secondary' style={{ lineHeight: '24px' }}>
                                                            {selectedCard ? 'OTHER' : 'SELECT CARD'}
                                                        </If>
                                                    </div>
                                                </div>
                                                <Divider variant='fullWidth'/>
                                                <div className={classes.registerDivDesktop}>
                                                    <Button className={classes.registerButtonDesktop}
                                                            disabled={this.state.paying}
                                                            onClick={this.pay.bind(this)}
                                                            color='secondary'
                                                            variant='contained'>
                                                        <div style={{ display: 'inline-flex' }}>
                                                            PAY <CircularProgress size={20} id='progress'
                                                                                  style={{
                                                                                      display: this.state.paying !== true && 'none',
                                                                                      alignSelf: 'center'
                                                                                  }}/>
                                                        </div>
                                                    </Button>
                                                </div>
                                            </Fragment>
                                        )
                                    }

                                    <If as={Paper} condition={!loadingPendingPayment && !!aptmData}
                                        className={classes.fixedPaper}>
                                        <Button className={classes.registerButton}
                                                disabled={this.state.paying}
                                                onClick={this.pay.bind(this)}
                                                color='secondary'
                                                variant='contained'>
                                            <div style={{ display: 'inline-flex' }}>
                                                PAY <CircularProgress size={20} id='progress'
                                                                      style={{
                                                                          display: this.state.paying !== true && 'none',
                                                                          alignSelf: 'center'
                                                                      }}/>
                                            </div>
                                        </Button>
                                    </If>

                                </Fragment>
                            )
                    }

                </div>
            </Fragment>
        )
    }

}

const mapStateToProps = state => ({
    loadingPendingPayment: state.pendingPayment.loading,
    pendingPaymentData: state.pendingPayment.data,
    cardsList: state.cardsList,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        loadPaymentPending,
        removeNotification: remove_notification,
        receiveCards: receive_cards,
    }, dispatch)
});

const OrderPaymentContentStyled = withStyles(styles)(OrderPaymentContent);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(OrderPaymentContentStyled));
